import FundraiserCard from "./FundraiserCard";
import type { SectionItem } from "@/api";

interface Props {
  items: SectionItem[];
}

export default function FundraiserCarousel({ items }: Props) {
  if (items.length === 0) return null;

  return (
    <div
      style={{
        display: "flex",
        overflowX: "auto",
        scrollSnapType: "x mandatory",
        gap: 10,
        paddingBottom: 4,
        paddingLeft: 16,
        paddingRight: 16,
        scrollPaddingLeft: 16,
        scrollPaddingRight: 16,
        msOverflowStyle: "none",
        scrollbarWidth: "none",
      }}
      className="carousel-no-scrollbar"
    >
      {items.map((item) => (
        <div
          key={item.id}
          style={{
            flexShrink: 0,
            width: 260,
            scrollSnapAlign: "start",
            display: "flex",
          }}
        >
          <FundraiserCard
            id={item.id}
            kind={item.kind}
            title={item.title}
            subtitle={item.subtitle}
            image={item.image}
            uniform
          />
        </div>
      ))}
    </div>
  );
}
